<template>
  <el-dialog
      title="Cấu hình App OneKids"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="closeDialog"
      :close-on-click-modal="false"

      top="3vh"
  >


    <div class="schoolConfigOneKids">


      <el-row type="flex" :gutter="10">

        <el-col :span="8">
          <el-col :span="8" style="margin-bottom: 10px;">
            <el-input
                style="width: 545px"
                v-model="searchByIdName"
                placeholder="Tìm kiếm theo tên trường"
                @input="filterList"
                prefix-icon="el-icon-search"
            />

          </el-col>
          <el-table
              style="margin-top:50px "
              border
              :data="schoolList"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              @select="handleSelectionChange"
              @select-all="handleSelectionAll"
              :reserve-selection="true"
              v-loading="loadingData"
              ref="tableSchool"
          >
            <el-table-column
                type="selection"
                width="55"
                align="center"
            />

            <el-table-column
                type="index"
                label="STT"
                align="center"
                width="50"
            ></el-table-column>

            <el-table-column
                label="Tên trường"
            >
              <template v-slot:default="scope">
                <span
                >{{ scope.row.id }} - {{ scope.row.schoolName }}</span>
              </template>
            </el-table-column>

            <template #empty>
              <div style="color: #409EFF; font-size: 16px">
                    <span>
                      <i class="el-icon-warning"/>
                      Không có dữ liệu
                    </span>
              </div>
            </template>
          </el-table>

          <el-col :span="23" style="margin-top: 15px;">
             <span
                 style="color: red">Chú ý: Lựa chọn trạng thái bật/tắt, tất cả các thay đổi sẽ được áp dụng dựa trên trạng thái đã chọn. </span>

          </el-col>
        </el-col>


        <el-col :span="16">

          <el-tabs type="card" v-model="activeTab" class="el_tabs_app">

            <!--OneTeacher-->
            <el-tab-pane label="App Teacher" name="OneTeacher">

              <div class="container_data">

                <el-tabs v-model="activeTabTeacher" type="card" @tab-click="handleClick" class="al_tabs-on_off">


                  <el-tab-pane label="Bật" name="true">
                    <div style="display: flex; justify-content: center">
                      <div class="table-icon-1">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>


                          <tr align="center">
                            <td class="table-index">1</td>
                            <td>Lời nhắn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.messageShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.message"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">2</td>
                            <td>Dặn thuốc</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.medicineShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.medicine"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">3</td>
                            <td>Xin nghỉ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.absentShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.absent"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">4</td>
                            <td>Sức khỏe</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.healthShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.health"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">5</td>
                            <td>Điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.attendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.attendance"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">6</td>
                            <td>Album ảnh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.albumShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.album"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">7</td>
                            <td>Nhận xét</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.evaluateShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.evaluate"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">8</td>
                            <td>Học phí</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.studentFeesShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.studentFees"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">9</td>
                            <td>Video</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.videoShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.video"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">10</td>
                            <td>Học tập</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.learnShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.learn"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">11</td>
                            <td>Thực đơn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.menuShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.menu"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="table-icon-2">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>

                          <tr align="center">
                            <td class="table-index">12</td>
                            <td>Sinh nhật</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.birthdayShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.birthday"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">13</td>
                            <td>Camera</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.cameraShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.camera"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">14</td>
                            <td>Tiện ích</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.utilityShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.utility"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">15</td>
                            <td>Công lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.salaryShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.salary"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">16</td>
                            <td>Facebook</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.facebookShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.facebook"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">17</td>
                            <td>Góp ý</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.feedbackShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.feedback"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">18</td>
                            <td>Tin tức</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.newsShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.news"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">19</td>
                            <td>Bảng lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.salaryShowNew"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.salaryNew"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">20</td>
                            <td>Quét mã QR</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.qrCodeShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.qrCode"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">21</td>
                            <td>Tạo khảo sát</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.surveyShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.survey"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">22</td>
                            <td>Quản lý điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.qlAttendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.qlAttendance"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">23</td>
                            <td>Quản lý nhận diện AI</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.attendanceAIShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.attendanceAI"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>


                  </el-tab-pane>
                  <el-tab-pane label="Tắt" name="false">
                    <div style="display: flex; justify-content: center">
                      <div class="table-icon-1">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>


                          <tr align="center">
                            <td class="table-index">1</td>
                            <td>Lời nhắn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.messageShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.message"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">2</td>
                            <td>Dặn thuốc</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.medicineShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.medicine"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">3</td>
                            <td>Xin nghỉ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.absentShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.absent"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">4</td>
                            <td>Sức khỏe</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.healthShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.health"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">5</td>
                            <td>Điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.attendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.attendance"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">6</td>
                            <td>Album ảnh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.albumShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.album"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">7</td>
                            <td>Nhận xét</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.evaluateShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.evaluate"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">8</td>
                            <td>Học phí</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.studentFeesShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.studentFees"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">9</td>
                            <td>Video</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.videoShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.video"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">10</td>
                            <td>Học tập</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.learnShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.learn"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">11</td>
                            <td>Thực đơn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.menuShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.menu"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="table-icon-2">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr align="center">
                            <td class="table-index">12</td>
                            <td>Sinh nhật</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.birthdayShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.birthday"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">13</td>
                            <td>Camera</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.cameraShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.camera"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">14</td>
                            <td>Tiện ích</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.utilityShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.utility"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">15</td>
                            <td>Công lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.salaryShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.salary"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">16</td>
                            <td>Facebook</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.facebookShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.facebook"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">17</td>
                            <td>Góp ý</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.feedbackShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.feedback"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">18</td>
                            <td>Tin tức</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.newsShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.news"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">19</td>
                            <td>Bảng lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.salaryShowNew"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.salaryNew"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">20</td>
                            <td>Quét mã QR</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.qrCodeShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.qrCode"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">21</td>
                            <td>Tạo khảo sát</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.surveyShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.survey"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">22</td>
                            <td>Quản lý điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.qlAttendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.qlAttendance"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">23</td>
                            <td>Quản lý nhận diện AI</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.attendanceAIShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconTeacherData.attendanceAI"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>


                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-tab-pane>

            <!--        Kids-->
            <el-tab-pane label="App Kids" name="OneKids">
              <div class="container_data">
                <el-tabs v-model="activeTabParent" type="card" @tab-click="clickParent" class="al_tabs-on_off">
                  <el-tab-pane label="Bật" name="true">
                    <div style="display: flex; justify-content: center">
                      <div class="table-icon-1">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr align="center">
                            <td class="table-index">1</td>
                            <td> Lời nhắn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.messageShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.message"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">2</td>
                            <td> Dặn thuốc</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.medicineShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.medicine"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">3</td>
                            <td>Xin nghỉ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.absentShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.absent"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">4</td>
                            <td>Album ảnh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.albumShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.album"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">5</td>
                            <td>Nhận xét</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.evaluateShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.evaluate"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">6</td>
                            <td>Điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.attendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.attendance"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">7</td>
                            <td>Quản lý học phí</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.newTuitionShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.newTuition"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">8</td>
                            <td>Học phí</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.studentFeesShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.studentFees"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">9</td>
                            <td>Học tập</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.learnShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.learn"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">10</td>
                            <td>Thực đơn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.menuShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.menu"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">11</td>
                            <td>Video</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.videoShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.video"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="table-icon-2">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr align="center">
                            <td class="table-index">12</td>
                            <td>Camera</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.cameraShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.camera"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">13</td>
                            <td>Con yêu</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.kidsInfoShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.kidsInfo"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">14</td>
                            <td> Facebook</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.facebookShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.facebook"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">15</td>
                            <td>Góp ý</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.feedbackShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.feedback"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">16</td>
                            <td>Tin tức</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.newsShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.news"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">17</td>
                            <td>Quét mã QR</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.qrCodeShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.qrCode"></el-checkbox>
                            </td>
                          </tr>


                          <tr align="center">
                            <td class="table-index">18</td>
                            <td>Khảo sát</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.surveyShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.survey"></el-checkbox>
                            </td>
                          </tr>


                          </tbody>
                        </table>
                      </div>
                    </div>


                  </el-tab-pane>
                  <el-tab-pane label="Tắt" name="false">

                    <div style="display: flex; justify-content: center">
                      <div class="table-icon-1">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr align="center">
                            <td class="table-index">1</td>
                            <td> Lời nhắn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.messageShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.message"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">2</td>
                            <td> Dặn thuốc</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.medicineShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.medicine"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">3</td>
                            <td>Xin nghỉ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.absentShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.absent"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">4</td>
                            <td>Album ảnh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.albumShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.album"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">5</td>
                            <td>Nhận xét</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.evaluateShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.evaluate"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">6</td>
                            <td>Điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.attendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.attendance"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">7</td>
                            <td>Quản lý học phí</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.newTuitionShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.newTuition"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">8</td>
                            <td>Học phí</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.studentFeesShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.studentFees"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">9</td>
                            <td>Học tập</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.learnShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.learn"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">10</td>
                            <td>Thực đơn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.menuShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.menu"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">11</td>
                            <td>Video</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.videoShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.video"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="table-icon-2">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr align="center">
                            <td class="table-index">12</td>
                            <td>Camera</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.cameraShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.camera"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">13</td>
                            <td>Con yêu</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.kidsInfoShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.kidsInfo"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">14</td>
                            <td> Facebook</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.facebookShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.facebook"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">15</td>
                            <td>Góp ý</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.feedbackShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.feedback"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">16</td>
                            <td>Tin tức</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.newsShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.news"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">17</td>
                            <td>Quét mã QR</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.qrCodeShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.qrCode"></el-checkbox>
                            </td>
                          </tr>


                          <tr align="center">
                            <td class="table-index">18</td>
                            <td>Khảo sát</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.surveyShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconParentData.survey"></el-checkbox>
                            </td>
                          </tr>


                          </tbody>
                        </table>
                      </div>
                    </div>

                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-tab-pane>

            <!--        Plus-->

            <el-tab-pane label="App Plus" name="OnePlus">

              <div class="container_data">
                <el-tabs v-model="activeTabPlus" type="card" @tab-click="handleClickPlus" class="al_tabs-on_off">
                  <el-tab-pane label="Bật" name="true">
                    <div style="display: flex; justify-content: center">
                      <div class="table-icon-1">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr align="center">
                            <td class="table-index">1</td>
                            <td>Nhân sự</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.employeeShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.employee"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">2</td>
                            <td>Học sinh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.kidsShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.kids"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">3</td>
                            <td>Lời nhắn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.messageShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.message"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">4</td>
                            <td>Dặn thuốc</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.medicineShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.medicine"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">5</td>
                            <td>Xin nghỉ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.absentShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.absent"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">6</td>
                            <td>Điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendance"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">7</td>
                            <td>Nhận xét</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.evaluateShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.evaluate"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">8</td>
                            <td>Album ảnh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.albumShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.album"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">9</td>
                            <td>Sức khỏe</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.healthShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.health"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">10</td>
                            <td>Học tập</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.learnShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.learn"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">11</td>
                            <td>Thực đơn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.menuShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.menu"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">12</td>
                            <td>Video</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.videoShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.video"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">13</td>
                            <td>Camera</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.cameraShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.camera"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">14</td>
                            <td>Sinh nhật</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.birthdayShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.birthday"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">15</td>
                            <td> Quản lý học phí
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studentFeesShowNew"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studentFeesNew"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">16</td>
                            <td>Học phí</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studentFeesShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studentFees"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">17</td>
                            <td> Công lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salary"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">18</td>
                            <td>Tiện ích</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.utilityShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.utility"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">19</td>
                            <td>Facebook</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.facebookShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.facebook"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">20</td>
                            <td>Góp ý</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.feedbackShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.feedback"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">21</td>
                            <td>Lịch sử</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.smsAppHistoryShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.smsAppHistory"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="table-icon-2">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr align="center">
                            <td class="table-index">22</td>
                            <td>Thông báo hệ thống</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.notifyShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.notify"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">23</td>
                            <td>Hỗ trợ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.supportShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.support"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">24</td>
                            <td>Thu chi nội bộ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.cashInternalShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.cashInternal"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">25</td>
                            <td>Ví</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.walletShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.wallet"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">26</td>
                            <td>Tin tức</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.newsShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.news"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">27</td>
                            <td>Xin nghỉ nhân sự</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.absentTeacherShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.absentTeacher"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">28</td>
                            <td>Chấm công nhân sự
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceTeacherShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceTeacher"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">29</td>
                            <td>Công lương nhân sự</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryTeacherShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryTeacher"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">30</td>
                            <td>Thống kê công lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.statisticSalaryTeacherShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.statisticSalaryTeacher"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">31</td>
                            <td>Bảng lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryTeacherShowNew"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryTeacherNew"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">32</td>
                            <td>Tổng học sinh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.totalKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.totalKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">33</td>
                            <td>Đang học</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studyingKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studyingKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">34</td>
                            <td>Đã điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">35</td>
                            <td>Chưa điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.noAttendanceKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.noAttendanceKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">36</td>
                            <td>Đi học</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.goSchoolKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.goSchoolKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">37</td>
                            <td>Đã điểm danh về</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.leaveSchoolKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.leaveSchoolKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">38</td>
                            <td>Đi học dự kiến</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.learnFutureStatusShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.learnFutureStatus"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">39</td>
                            <td>Mã QR</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.qrCodeShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.qrCode"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">40</td>
                            <td>Nhận diện</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.faceRecognitionShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.faceRecognition"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">41</td>
                            <td>Quản lý điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.qlAttendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.qlAttendance"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">42</td>
                            <td>Quản lý nhận diện AI</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceAIShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceAI"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>


                  </el-tab-pane>
                  <el-tab-pane label="Tắt" name="false">
                    <div style="display: flex; justify-content: center">
                      <div class="table-icon-1">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr align="center">
                            <td class="table-index">1</td>
                            <td>Nhân sự</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.employeeShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.employee"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">2</td>
                            <td>Học sinh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.kidsShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.kids"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">3</td>
                            <td>Lời nhắn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.messageShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.message"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">4</td>
                            <td>Dặn thuốc</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.medicineShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.medicine"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">5</td>
                            <td>Xin nghỉ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.absentShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.absent"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">6</td>
                            <td>Điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendance"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">7</td>
                            <td>Nhận xét</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.evaluateShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.evaluate"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">8</td>
                            <td>Album ảnh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.albumShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.album"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">9</td>
                            <td>Sức khỏe</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.healthShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.health"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">10</td>
                            <td>Học tập</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.learnShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.learn"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">11</td>
                            <td>Thực đơn</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.menuShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.menu"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">12</td>
                            <td>Video</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.videoShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.video"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">13</td>
                            <td>Camera</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.cameraShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.camera"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">14</td>
                            <td>Sinh nhật</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.birthdayShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.birthday"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">15</td>
                            <td> Quản lý học phí
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studentFeesShowNew"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studentFeesNew"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">16</td>
                            <td>Học phí</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studentFeesShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studentFees"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">17</td>
                            <td> Công lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salary"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">18</td>
                            <td>Tiện ích</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.utilityShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.utility"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">19</td>
                            <td>Facebook</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.facebookShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.facebook"></el-checkbox>
                            </td>
                          </tr>

                          <tr align="center">
                            <td class="table-index">20</td>
                            <td>Góp ý</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.feedbackShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.feedback"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">21</td>
                            <td>Lịch sử</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.smsAppHistoryShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.smsAppHistory"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="table-icon-2">
                        <table border class="table-data">
                          <thead class="table-header">
                          <tr align="center">
                            <td class="table-index">STT</td>
                            <td style="text-align: center">Chức năng</td>
                            <td class="table-action">Hiển thị</td>
                            <td class="table-action">Mở khóa</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr align="center">
                            <td class="table-index">22</td>
                            <td>Thông báo hệ thống</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.notifyShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.notify"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">23</td>
                            <td>Hỗ trợ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.supportShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.support"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">24</td>
                            <td>Thu chi nội bộ</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.cashInternalShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.cashInternal"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">25</td>
                            <td>Ví</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.walletShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.wallet"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">26</td>
                            <td>Tin tức</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.newsShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.news"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">27</td>
                            <td>Xin nghỉ nhân sự</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.absentTeacherShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.absentTeacher"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">28</td>
                            <td>Chấm công nhân sự
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceTeacherShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceTeacher"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">29</td>
                            <td>Công lương nhân sự</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryTeacherShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryTeacher"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">30</td>
                            <td>Thống kê công lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.statisticSalaryTeacherShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.statisticSalaryTeacher"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">31</td>
                            <td>Bảng lương</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryTeacherShowNew"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.salaryTeacherNew"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">32</td>
                            <td>Tổng học sinh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.totalKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.totalKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">33</td>
                            <td>Đang học</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studyingKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.studyingKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">34</td>
                            <td>Đã điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">35</td>
                            <td>Chưa điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.noAttendanceKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.noAttendanceKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">36</td>
                            <td>Đi học</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.goSchoolKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.goSchoolKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">37</td>
                            <td>Đã điểm danh về</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.leaveSchoolKidStatisticShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.leaveSchoolKidStatistic"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">38</td>
                            <td>Đi học dự kiến</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.learnFutureStatusShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.learnFutureStatus"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">39</td>
                            <td>Mã QR</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.qrCodeShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.qrCode"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">40</td>
                            <td>Nhận diện</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.faceRecognitionShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.faceRecognition"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">41</td>
                            <td>Quản lý điểm danh</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.qlAttendanceShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.qlAttendance"></el-checkbox>
                            </td>
                          </tr>
                          <tr align="center">
                            <td class="table-index">42</td>
                            <td>Quản lý nhận diện AI</td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceAIShow"></el-checkbox>
                            </td>
                            <td class="table-action">
                              <el-checkbox v-model="iconPlusData.attendanceAI"></el-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>


                  </el-tab-pane>
                </el-tabs>
              </div>


            </el-tab-pane>

          </el-tabs>
        </el-col>
      </el-row>
    </div>


    <br>
    <br>

    <span slot="footer" class="dialog-footer">
      <el-button
          type="danger"
          size="medium"
          @click="closeDialogByButton('iconParentData')"
      >
        <i class="el-icon-circle-close"/>
        <span>Đóng</span>
      </el-button>
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm()"
      >
        <i class="el-icon-circle-check"/>
        <span>Lưu</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>


import SystemConfigService from "@/services/AdminService/SystemConfigService";
import AgentService from "@/services/AdminService/AgentService";

export default {
  props: {
    dialogVisible: null,
    idAgent: null,

  },
  data() {
    return {
      searchByIdName: '',
      schoolListDefault: [],
      dialogData: null,
      loadingData: false,
      selectedFunctionsTeacherIcon: [],
      selectedFunctionsPlusIcon: [],
      selectedFunctionsParentIcon: [],
      idSchoolAdd: [],
      schoolList: [],
      selectionSchool: [],
      schoolActiveList: [
        {
          id: 1, value: true, label: "Kích hoạt"
        },
        {
          id: 2, value: false, label: "Chưa kích hoạt"
        },
      ],
      idSchoolList: [],
      activeTab: "OneTeacher",
      activeTabTeacher: "true",
      activeTabPlus: "true",
      activeTabParent: "true",

      iconPlusData: {
        absent: false,
        absentShow: false,
        absentTeacher: false,
        absentTeacherShow: false,
        album: false,
        albumShow: false,
        attendance: false,
        attendanceKidStatistic: false,
        attendanceKidStatisticShow: false,
        attendanceShow: false,
        attendanceTeacher: false,
        attendanceTeacherShow: false,
        birthday: false,
        birthdayShow: false,
        camera: false,
        cameraShow: false,
        cashInternal: false,
        cashInternalShow: false,
        employee: false,
        employeeShow: false,
        evaluate: false,
        evaluateShow: false,
        faceRecognition: false,
        faceRecognitionShow: false,
        facebook: false,
        facebookShow: false,
        feedback: false,
        feedbackShow: false,
        goSchoolKidStatistic: false,
        goSchoolKidStatisticShow: false,
        health: false,
        healthShow: false,
        kids: false,
        kidsShow: false,
        learn: false,
        learnFutureStatus: false,
        learnFutureStatusShow: false,
        learnShow: false,
        leaveSchoolKidStatistic: false,
        leaveSchoolKidStatisticShow: false,
        medicine: false,
        medicineShow: false,
        menu: false,
        menuShow: false,
        message: false,
        messageShow: false,
        news: false,
        newsShow: false,
        noAttendanceKidStatistic: false,
        noAttendanceKidStatisticShow: false,
        notify: false,
        notifyShow: false,
        qlAttendance: false,
        qlAttendanceShow: false,
        qrCode: false,
        qrCodeShow: false,
        salary: false,
        salaryShow: false,
        salaryTeacher: false,
        salaryTeacherNew: false,
        salaryTeacherShow: false,
        salaryTeacherShowNew: false,
        smsAppHistory: false,
        smsAppHistoryShow: false,
        statisticSalaryTeacher: false,
        statisticSalaryTeacherShow: false,
        studentFees: false,
        studentFeesNew: false,
        studentFeesShow: false,
        studentFeesShowNew: false,
        studyingKidStatistic: false,
        studyingKidStatisticShow: false,
        support: false,
        supportShow: false,
        totalKidStatistic: false,
        totalKidStatisticShow: false,
        utility: false,
        utilityShow: false,
        video: false,
        videoShow: false,
        wallet: false,
        walletShow: false,
        attendanceAIShow: false,
        attendanceAI: false,
      }
      ,
      iconTeacherData: {
        message: false,
        medicine: false,
        absent: false,
        health: false,
        attendance: false,
        album: false,
        evaluate: false,
        studentFees: false,
        video: false,
        learn: false,
        menu: false,
        birthday: false,
        camera: false,
        utility: false,
        salary: false,
        facebook: false,
        feedback: false,
        news: false,
        salaryNew: false,
        qrCode: false,
        survey: false,
        qlAttendance: false,
        messageShow: false,
        medicineShow: false,
        absentShow: false,
        healthShow: false,
        attendanceShow: false,
        albumShow: false,
        evaluateShow: false,
        studentFeesShow: false,
        videoShow: false,
        learnShow: false,
        menuShow: false,
        birthdayShow: false,
        cameraShow: false,
        utilityShow: false,
        salaryShow: false,
        facebookShow: false,
        feedbackShow: false,
        newsShow: false,
        salaryShowNew: false,
        qrCodeShow: false,
        surveyShow: false,
        qlAttendanceShow: false,
        backgroundColorIconTeacher: "",
        attendanceAIShow: false,
        attendanceAI: false,
      },
      iconParentData: {
        absent: false,
        absentShow: false,
        album: false,
        albumShow: false,
        attendance: false,
        attendanceShow: false,
        camera: false,
        cameraShow: false,
        evaluate: false,
        evaluateShow: false,
        facebook: false,
        facebookShow: false,
        feedback: false,
        feedbackShow: false,
        kidsInfo: false,
        kidsInfoShow: false,
        learn: false,
        learnShow: false,
        medicine: false,
        medicineShow: false,
        menu: false,
        menuShow: false,
        message: false,
        messageShow: false,
        newTuition: false,
        newTuitionShow: false,
        news: false,
        newsShow: false,
        qrCode: false,
        qrCodeShow: false,
        studentFees: false,
        studentFeesShow: false,
        survey: false,
        surveyShow: false,
        video: false,
        videoShow: false,


      },

      listId: [],
      loadingButton: false,
      id: "",
      colorValue: 0,
      dataSearch: {

        idAgent: "",
        schoolName: "",
        schoolActive: true,
      },

    };
  },
  created() {
    this.findAllAppIconForSchool()
  },
  methods: {


    clickParent() {
      this.iconParentData = {
        absent: false,
        absentShow: false,
        album: false,
        albumShow: false,
        attendance: false,
        attendanceShow: false,
        camera: false,
        cameraShow: false,
        evaluate: false,
        evaluateShow: false,
        facebook: false,
        facebookShow: false,
        feedback: false,
        feedbackShow: false,
        kidsInfo: false,
        kidsInfoShow: false,
        learn: false,
        learnShow: false,
        medicine: false,
        medicineShow: false,
        menu: false,
        menuShow: false,
        message: false,
        messageShow: false,
        newTuition: false,
        newTuitionShow: false,
        news: false,
        newsShow: false,
        qrCode: false,
        qrCodeShow: false,
        studentFees: false,
        studentFeesShow: false,
        survey: false,
        surveyShow: false,
        video: false,
        videoShow: false,

      }

    },


    handleClickPlus() {
      this.iconPlusData = {
        absent: false,
        absentShow: false,
        absentTeacher: false,
        absentTeacherShow: false,
        album: false,
        albumShow: false,
        attendance: false,
        attendanceKidStatistic: false,
        attendanceKidStatisticShow: false,
        attendanceShow: false,
        attendanceTeacher: false,
        attendanceTeacherShow: false,
        birthday: false,
        birthdayShow: false,
        camera: false,
        cameraShow: false,
        cashInternal: false,
        cashInternalShow: false,
        employee: false,
        employeeShow: false,
        evaluate: false,
        evaluateShow: false,
        faceRecognition: false,
        faceRecognitionShow: false,
        facebook: false,
        facebookShow: false,
        feedback: false,
        feedbackShow: false,
        goSchoolKidStatistic: false,
        goSchoolKidStatisticShow: false,
        health: false,
        healthShow: false,
        kids: false,
        kidsShow: false,
        learn: false,
        learnFutureStatus: false,
        learnFutureStatusShow: false,
        learnShow: false,
        leaveSchoolKidStatistic: false,
        leaveSchoolKidStatisticShow: false,
        medicine: false,
        medicineShow: false,
        menu: false,
        menuShow: false,
        message: false,
        messageShow: false,
        news: false,
        newsShow: false,
        noAttendanceKidStatistic: false,
        noAttendanceKidStatisticShow: false,
        notify: false,
        notifyShow: false,
        qlAttendance: false,
        qlAttendanceShow: false,
        qrCode: false,
        qrCodeShow: false,
        salary: false,
        salaryShow: false,
        salaryTeacher: false,
        salaryTeacherNew: false,
        salaryTeacherShow: false,
        salaryTeacherShowNew: false,
        smsAppHistory: false,
        smsAppHistoryShow: false,
        statisticSalaryTeacher: false,
        statisticSalaryTeacherShow: false,
        studentFees: false,
        studentFeesNew: false,
        studentFeesShow: false,
        studentFeesShowNew: false,
        studyingKidStatistic: false,
        studyingKidStatisticShow: false,
        support: false,
        supportShow: false,
        totalKidStatistic: false,
        totalKidStatisticShow: false,
        utility: false,
        utilityShow: false,
        video: false,
        videoShow: false,
        wallet: false,
        walletShow: false,
        attendanceAIShow: false,
        attendanceAI: false,
      }
    },
    handleClick() {
      this.iconTeacherData = {
        message: false,
        medicine: false,
        absent: false,
        health: false,
        attendance: false,
        album: false,
        evaluate: false,
        studentFees: false,
        video: false,
        learn: false,
        menu: false,
        birthday: false,
        camera: false,
        utility: false,
        salary: false,
        facebook: false,
        feedback: false,
        news: false,
        salaryNew: false,
        qrCode: false,
        survey: false,
        qlAttendance: false,
        messageShow: false,
        medicineShow: false,
        absentShow: false,
        healthShow: false,
        attendanceShow: false,
        albumShow: false,
        evaluateShow: false,
        studentFeesShow: false,
        videoShow: false,
        learnShow: false,
        menuShow: false,
        birthdayShow: false,
        cameraShow: false,
        utilityShow: false,
        salaryShow: false,
        facebookShow: false,
        feedbackShow: false,
        newsShow: false,
        salaryShowNew: false,
        qrCodeShow: false,
        surveyShow: false,
        qlAttendanceShow: false,
        backgroundColorIconTeacher: "",
        attendanceAIShow: false,
        attendanceAI: false,
      }
    },
    //reset when click x
    closeDialog() {
      this.dialogVisible = false; // Đóng dialog
      this.$emit("dialog-close");
      this.resetData();
      setTimeout(() => {
        this.$refs["iconParentData"].resetFields();

      }, 300);
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    //click when click button
    closeDialogByButton(fromData) {

      this.colorValue = 0;
      this.currentColor = `hsl(0, 100%, 85%)`;
      this.$emit("dialog-close");
      this.resetData();
      setTimeout(() => {
        this.$refs[fromData].resetFields();
      }, 300);
    },
    filterList() {
      this.loadingData = true
      const query = this.searchByIdName.trim();

      const isNumber = !isNaN(query) && query !== "";

      this.schoolList = [];

      if (query !== '') {
        this.schoolList = this.schoolListDefault.filter(item =>
            isNumber
                ? item.id === Number(query)
                : item.schoolName.toLowerCase().includes(query.toString().toLowerCase())
        );
      } else {
        this.schoolList = [...this.schoolListDefault];
      }

      this.schoolList = this.schoolList.reduce((acc, item) => {
        if (!acc.some(obj => obj.id === item.id)) {
          acc.push(item);
        }
        return acc;
      }, []);

      this.addCheckSchool();
      this.loadingData = false;
      // // Đồng bộ lại selection sau khi cập nhật dữ liệu
      // this.$nextTick(() => {
      //   this.idSchoolAdd.forEach(id => {
      //     const row = this.schoolList.find(item => item.id === id);
      //     if (row) this.$refs.table.toggleRowSelection(row, true);
      //   });
      // });
    },


    submitForm() {

        const idSchool = this.selectionSchool.map(item => item.id);

        if (idSchool.length > 0) {
          const loading = this.$loading({
            lock: true,
            text: 'Đang tải',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });


          const autoUpdateAppIcon = {
            iconTeacherConfigRequest: this.iconTeacherData,
            iconParentConfigRequest: this.iconParentData,
            iconPlusConfigRequest: this.iconPlusData,
            listIdSchool: idSchool,
            active: this.activeTabTeacher,
            activePlus: this.activeTabPlus,
            activeParent: this.activeTabParent,

          }
          SystemConfigService.autoUpdateSchoolIcon(autoUpdateAppIcon)
              .then((resp) => {
                console.log(resp.data)
                this.closeDialog()
                this.handleClick()
                loading.close()
                this.resetData()
                this.$message({
                  message: "Thiết lập thành công",
                  type: "success",
                });

              })
              .catch((err) => {
                console.log(err);
                this.resetData();
                loading.close()
                this.$message({
                  message: "Thiết lập thất bại",
                  type: "error",
                });
              });


        } else {
          this.resetData()
          this.$message({
            message: "Thiết lập thất bại",
            type: "error",
          });
        }















    },
    getRowKey(row) {
      return row.id;
    },

    findAllAppIconForSchool() {
      this.loadingData = true;
      SystemConfigService.findSchoolConfig(
          this.idAgent,
          this.dataSearch.schoolName,
          true,
      )
          .then((resp) => {

            const dataFromApi = resp.data.data;
            // if (this.dataSearch.schoolName === "") {
            //   this.schoolList = dataFromApi;
            // } else {
            //   this.schoolList = dataFromApi.filter(school =>
            //       school.schoolName.toLowerCase().includes(this.dataSearch.schoolName.toLowerCase())
            //   );
            // }

            dataFromApi.forEach(item => {
              this.schoolList.push(item);
              this.schoolListDefault.push(item);
            })
            // this.schoolList = dataFromApi;
            // this.schoolListDefaul = dataFromApi;
            this.loadingData = false;

          })
          .catch((err) => {
            console.log(err);
            this.appIconForSchoolList = null;
            this.loadingData = false;
          })
          .finally(() => {
            if (this.appIconForSchoolList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });


    },

    handleSelectionChange(selection, row) {
      // value.forEach(item => {
      //   console.log(item.id)
      //   if (!this.idSchoolAdd.includes(item.id)) {
      //     this.idSchoolAdd.push(item.id)
      //   }
      // })
      // console.log(this.idSchoolAdd)
      // this.idSchoolAdd = value.map(row => row.id);

      if (selection.length > 0) {
        let exists = selection.some(item => item.id === row.id);
        if (exists) {
          this.selectionSchool.push(row);
        } else {
          this.selectionSchool = this.selectionSchool.filter(item => item.id !== row.id);
        }
      } else {
        this.selectionSchool = this.selectionSchool.filter(item => item.id !== row.id);
      }

      this.removeDuplicateSelectionSchool();
    },

    removeDuplicateSelectionSchool() {
      this.selectionSchool = this.selectionSchool.reduce((acc, item) => {
        if (!acc.some(obj => obj.id === item.id)) {
          acc.push(item);
        }
        return acc;
      }, []);
    },

    handleSelectionAll(selection) {
      this.selectionSchool = [...selection];
      this.removeDuplicateSelectionSchool();
    },

    addCheckSchool() {
      this.$nextTick(() => {
        this.selectionSchool.forEach(item => {
          this.$refs.tableSchool.toggleRowSelection(item, true);
        });
      });
    },

    findAllAgentUnique() {
      AgentService.getAll()
          .then((resp) => {
            this.agentList = resp.data.data.agentList;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    isRowSelected(id) {
      return this.idSchoolAdd.includes(id);
    },


    resetData() {
      this.listIdSchool = []
      this.schoolList = []
      this.idSchoolList = []
      this.idSchoolAdd = []
      this.selectionSchool = []
      this.handleClick();
      this.clickParent();
      this.handleClickPlus()

      this.activeTabTeacher = "true"
      this.activeTabPlus = "true"
      this.activeTabParent = "true"
      this.activeTab = "OneTeacher"
      this.searchByIdName = ''
      this.dataSearch.schoolName = ''
      this.dataSearch.schoolActive = ''
      this.dataSearch.idAgent = ''
      // Gọi lại phương thức tải dữ liệu
      this.findAllAppIconForSchool()
    },


  },
  beforeMount() {
    this.findAllAgentUnique();
    this.findAllAppIconForSchool();

  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {

        this.fetchData();
      }
    }
  },
  mounted() {

    this.fetchData();
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
}

.table-icon-1 {
  margin-left: 70px;
  margin-right: 60px;
}

.table-icon-2 {
  margin-right: 70px;
  margin-left: 60px;
}

.over-table {
  width: 100%;
  margin: 0 auto;
}

.table-data {
  border-collapse: collapse;
  border: 1px solid #ebeef5;
}

.wrapper-table {
  height: 600px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
}

tbody {
  color: #606266;
  font-size: 14px;
  overflow: auto;
  font-family: Arial, Helvetica, sans-serif;
}

td {
  padding: 10px;
}

.table-index {
  width: 30px;
}

.table-item-name {
  width: 200px;
  text-align: center;
}

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100px;
}

.circle-container {
  //margin-right: 2rem;
}

.color-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.slider-container {
  display: flex;
  align-items: center;
  width: 200px;
  position: relative;
}

input[type="range"] {
  -webkit-appearance: none;
  width: 100%;
  height: 20px;
  border-radius: 15px;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
}

input[type="range"]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.5);
}

.custom-delete-btn {
  font-size: 12px; /* Giảm kích thước chữ */
  padding: 3px 8px; /* Điều chỉnh kích thước padding để nút nhỏ hơn */
}

.container_data {
  border: 1px solid #78a5e7;
  min-height: 500px;
  padding: 20px 34px;

}

/deep/ .el-tabs__header {

  margin: 0;
}

/deep/ .el-tabs__nav-scroll {
  margin: 0 0 10px;
}

.highlighted {
  background-color: #f5f7fa; /* Màu nền sáng cho ô được chọn */
  color: #409EFF; /* Màu chữ sáng */
}

.el_tabs_app {
  /deep/ .el-tabs__nav-scroll {
    margin-bottom: 0;
  }
}

.al_tabs-on_off {
  /deep/ .el-tabs__nav-scroll {
    margin-bottom: 20px;
  }
}
</style>
